<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="5" xl="4">
        <v-card class="elevation-1 rounded-xl">
          <v-toolbar color="primary">
            <v-btn icon large>
              <v-avatar size="32px" item>
                <v-img src="/static/taptarget-logo-white.png"> </v-img>
              </v-avatar>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text font-weight-bold">
              TapTarget Key Vault
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-title
            :class="['font-weight-medium', 'text-h5', 'mx-5 mt-5']"
            style="word-break: break-word"
          >
            Inloggen
          </v-card-title>

          <v-card-subtitle :class="['mx-5']">
            Doorgaan naar TapTarget Key Vaults
          </v-card-subtitle>

          <v-card-text>
            <v-row class="mx-2 mt-4">
              <v-col :class="['mt-0', 'pt-0']" cols="12">
                <v-btn
                  @click="loginWithAzureAD()"
                  block
                  color="primary"
                  large
                  rounded
                >
                  <v-btn :class="['pa-2', 'mr-1']" icon>
                    <v-img
                      src="https://ltpbiportal.blob.core.windows.net/media/images/microsoft-logo.svg"
                      width="20"
                    ></v-img>
                  </v-btn>
                  Doorgaan met Microsoft
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<!-- <template>
	<v-container class="fill-height" fluid style="height: 100vh">
		<v-row class="fill-height" style="height: 100vh">
			<v-col sm="12" md="4">
				<v-card class="elevation-0" style="height: 40vh">
					<v-card-title>
						<h2 class="font-weight-black primary--text">
							LinkThings&nbsp;
						</h2>
						<h2 class="font-weight-black warning--text">
							Key Vault
						</h2>
					</v-card-title>
					<v-card-text>
						Secure all your secrets with LinkThings Key Vault! This
						Azure Key Vault integration provides a nice UI on top of
						the secure Azure service.
					</v-card-text>
				</v-card>
				<v-card class="elevation-0" style="height: 50vh">
					<v-card class="elevation-0">
						<v-card-title> No account yet? </v-card-title>
						<v-card-text>
							Want to start using Azure together with LinkThings
							in order to secure all your passwords?
						</v-card-text>
						<v-card-actions>
							<v-btn
								rounded
								color="orange"
								text
								href="mailto:jay@linkthings.com"
							>
								Contact
							</v-btn>
						</v-card-actions>
					</v-card>
					<v-divider></v-divider>

				</v-card>
				<v-card-actions>
					<v-btn
						rounded
						color="primary"
						text
						href="http://www.linkthings.com"
					>
						www.linkthings.com
					</v-btn>

					<v-btn
						rounded
						color="primary"
						text
						href="mailto:info@linkthings.com"
					>
						Support
					</v-btn>
				</v-card-actions>
			</v-col>
			<v-col sm="12" md="8" style="background-color: #10325a">
				<v-container class="fill-height" fluid>
					<v-row align="center" justify="center">
						<v-col sm="8" md="6">
							<v-card>
								<div class="ma-5">
									<v-img
										src="https://www.linkthings.com/assets/themes/site/img/logo.svg"
										width="500px"
									></v-img>
								</div>
								<v-card-actions>
									<v-btn
										color="primary"
										block
										rounded
										@click="loginWithAzureAD"
										>Login with Azure</v-btn
									>
								</v-card-actions>
							</v-card></v-col
						>
					</v-row>
				</v-container>
			</v-col>
		</v-row>
	</v-container>
</template> -->

<script>
import msalAuth from "@/utils/msalAuth.js";

export default {
  title: "login",
  data: function () {
    return {
      // account: null,
      // User account object synced with MSAL getAccount()
      msalUser: {},
      // Access token fetched via MSAL for calling Graph API
      msalAccessToken: "",
    };
  },

  computed: {},

  methods: {
    async loginWithAzureAD() {
      try {
        await msalAuth.login();
        this.msalUser = msalAuth.user();
        this.msalAccessToken = await msalAuth.acquireToken(["user.read"]);
        this.isLoggingIn = true;

        this.$store.commit("user/setIsLoggedIn");
        this.$router.push(this.$route.query.redirect || "/secrets");
      } catch (err) {
        console.log(err);
        this.error = err.toString();
      }
    },
  },
};
</script>
